import './TeamIcon.scss'
import React from 'react'
import { get } from 'lodash'
import classnames from 'classnames'
import { observer } from 'mobx-react'
import { teamStore } from '../app/stores'

const TeamIcon = ({ size, className }) => {
  const imgAlt = get(teamStore, 'team.slackData.team.name', 'team icon')
  const imgStyle = { width: size, height: size }
  return (
    <div className={classnames('TeamIcon', className)} style={imgStyle}>
      {teamStore.teamIcon && <img src={teamStore.teamIcon} alt={imgAlt} />}
    </div>
  )
}

TeamIcon.displayName = 'TeamIcon'

TeamIcon.defaultProps = {
  size: 40
}

export default observer(TeamIcon)



// WEBPACK FOOTER //
// ./src/lib/TeamIcon.js